// Un producto puede tener varios códigos de barra: el principal (`barcode`) y los
// adicionales (`extra_barcodes`), que corresponden a versiones nuevas del fabricante.

/**
 * Todos los códigos de barra del producto (principal primero), sin vacíos ni repetidos.
 * @param {Object} product
 * @returns {string[]}
 */
export function productBarcodes(product) {
  if (!product) return []
  const codes = [product.barcode, ...(product.extra_barcodes || []).map(b => b.barcode)]
  return [...new Set(codes.filter(Boolean).map(c => String(c).trim()))]
}

/**
 * Indica si el código escaneado corresponde a alguno de los códigos del producto.
 * @param {Object} product
 * @param {string} code
 * @returns {boolean}
 */
export function productHasBarcode(product, code) {
  if (!product || code === null || code === undefined) return false
  const target = String(code).trim()
  return !!target && productBarcodes(product).includes(target)
}

/**
 * Busca en una lista el producto que tiene el código (principal o adicional).
 * Da prioridad al código principal, igual que antes de existir los adicionales.
 * @param {Object[]} products
 * @param {string} code
 * @returns {Object|null}
 */
export function findProductByAnyBarcode(products, code) {
  if (!products || code === null || code === undefined) return null
  const target = String(code).trim()
  if (!target) return null
  return products.find(p => p.barcode === target) ||
    products.find(p => productHasBarcode(p, target)) ||
    null
}
